"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _Tab = _interopRequireDefault(require("./Tab"));

exports["default"] = _Tab["default"];